import { gql } from '@apollo/client';

export default gql`
  mutation addOneTimePaymentMutation($input: OneTimePaymentInvoiceInput) {
    createOneTimePaymentInvoice(input: $input) {
      id
      number
    }
  }
`;
